import { createFileRoute } from '@tanstack/react-router'

import UserPanel from '@/components/member/UserPanel'
import Box from '@mui/material/Box'

export const Route = createFileRoute(
    '/_auth/member_/$memberUuid/user',
)({
    component: MemberComponent,
})

function MemberComponent() {
    const params = Route.useParams()

    return (<>
        <Box sx={{ paddingBottom: 2 }}>
            <UserPanel memberUuid={params.memberUuid} />
        </Box>

    </>);
}
